import { render, staticRenderFns } from "./OrderFlowWaiterTable.vue?vue&type=template&id=664d628a&scoped=true"
import script from "./OrderFlowWaiterTable.vue?vue&type=script&lang=js"
export * from "./OrderFlowWaiterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d628a",
  null
  
)

export default component.exports